module.exports = __webpack_public_path__ + "static/media/on-ground-challenge-pic.d6a87441.png";